export const NAME_SPACE = 'AssetView';
export const extra = '';
